export default "<div class=\"name\">\n  {{name}}\n</div>\n"